var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFilledon = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19 3h-5v18h5V3ZM10 3H5v18h5V3Z",
  stroke: "currentColor",
  strokeWidth: 1.4,
  strokeLinecap: "round"
})));
export { SvgFilledon as ReactComponent };
export default __webpack_public_path__ + "53bcfe36d125aae2499d6224fc496c55.svg";